import React from 'react';
import { CustomTextArea, FormSelect} from '../../../../../components';
import { Col, Row } from 'antd';

const ManageStatusRequest = ({
  petitionStates,
  detailData,
  formikSolicitud
}: any) => {
  const getStatusValue = () => {
    const idMatchValue = petitionStates.find((state: any) => state.name === detailData?.status);
    formikSolicitud.setFieldValue('status_id', idMatchValue?.id || '')
    return idMatchValue?.id || '';
  };

  React.useEffect(() => {
    getStatusValue()
  }, [detailData?.status]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Estado de la solicitud"
            name="status_id"
            placeholder="Seleccione..."
            value={formikSolicitud.values.status_id?.toString()}
            options={[
              {
                name: 'Aprobada',
                id: '9'
              },
              {
                name: 'Rechazada',
                id: '28'
              }
            ]}
            error={formikSolicitud.errors.status_id}
            touched={formikSolicitud.touched.status_id}
            onChange={(value) =>
              formikSolicitud.setFieldValue('status_id', value)
            }
            onBlur={formikSolicitud.handleBlur}
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <CustomTextArea
            label="Observación"
            name="reason"
            placeholder="Inserte"
            value={ formikSolicitud.values.reason || detailData?.reason }
            error={formikSolicitud.errors.reason}
            touched={formikSolicitud.touched.reason}
            onChange={formikSolicitud.handleChange}
            onBlur={formikSolicitud.handleBlur}
          />
        </Col>
      </Row>
    </>
  );
};

export default ManageStatusRequest;
